var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9028da3bd5b1439a9e66c0e89309636a9e2a31ff"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["higo-app-production-next@payana"]={id:"9028da3bd5b1439a9e66c0e89309636a9e2a31ff"};
      